import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Facebook, Instagram } from 'lucide-react';
import { companyInfo } from '../data/mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#03224c] text-white">
      <div className="container mx-auto px-4 py-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src="/images/logo-blanc.png" 
              alt="Sunpac Energy" 
              className="h-16 w-auto mb-4"
            />
            <p className="text-gray-300 text-sm mb-3">
              {companyInfo.slogan}
            </p>
            <p className="text-gray-400 text-sm">
              Votre partenaire pour la transition énergétique en Suisse romande.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-base mb-3">Navigation</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-[#e57200] transition-colors text-sm">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/solutions" className="text-gray-300 hover:text-[#e57200] transition-colors text-sm">
                  Nos solutions
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-[#e57200] transition-colors text-sm">
                  À propos
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-[#e57200] transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Solutions */}
          <div>
            <h3 className="font-bold text-base mb-3">Nos solutions</h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>Panneaux solaires</li>
              <li>Pompes à chaleur</li>
              <li>Batteries de stockage</li>
              <li>Boilers thermodynamiques</li>
              <li>Isolation thermique</li>
              <li>Fenêtres</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-base mb-3">Contact</h3>
            <div className="space-y-2">
              <div className="flex items-start space-x-2">
                <MapPin size={16} className="text-[#e57200] mt-0.5 flex-shrink-0" />
                <span className="text-sm text-gray-300">{companyInfo.address}</span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone size={16} className="text-[#e57200] flex-shrink-0" />
                <div className="text-sm text-gray-300">
                  <div>{companyInfo.phone}</div>
                  <div>{companyInfo.mobile}</div>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <Mail size={16} className="text-[#e57200] flex-shrink-0" />
                <a href={`mailto:${companyInfo.email}`} className="text-sm text-gray-300 hover:text-[#e57200] transition-colors">
                  {companyInfo.email}
                </a>
              </div>
            </div>

            {/* Social Media */}
            <div className="flex items-center space-x-3 mt-4">
              <a href="#" className="text-gray-300 hover:text-[#e57200] transition-colors" aria-label="LinkedIn">
                <Linkedin size={18} />
              </a>
              <a href="#" className="text-gray-300 hover:text-[#e57200] transition-colors" aria-label="Facebook">
                <Facebook size={18} />
              </a>
              <a href="#" className="text-gray-300 hover:text-[#e57200] transition-colors" aria-label="Instagram">
                <Instagram size={18} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-4">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-3 md:space-y-0">
            <p className="text-xs text-gray-400">
              © {currentYear} {companyInfo.name}. Tous droits réservés.
            </p>
            <div className="flex items-center space-x-4 text-xs text-gray-400">
              <a href="/documents/mentions-legales.pdf" target="_blank" rel="noopener noreferrer" className="hover:text-[#e57200] transition-colors">
                Mentions légales
              </a>
              <a href="/documents/confidentialite.pdf" target="_blank" rel="noopener noreferrer" className="hover:text-[#e57200] transition-colors">
                Politique de confidentialité
              </a>
              <a href="/documents/cgv.pdf" target="_blank" rel="noopener noreferrer" className="hover:text-[#e57200] transition-colors">
                Conditions Générales de Vente
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
